<script>
    import SvelteMarkdown from 'svelte-markdown'
    const source = `TBD (cites Hanna)`
</script>

<section class="scale">
    <h2>Scale</h2>
    <SvelteMarkdown {source} />
</section>